import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getObjectKeys' })
export class GetObjectKeysPipe implements PipeTransform {
  transform(object: object): Array<string> {
    return Object.keys(object);
  }
}
